<template>
    <dev>
      <div v-if="matchingDevices[0]?.name!='tenant_payments'">
            <hb-empty-state 
                 message="Select Tenant Payments to activate this section." :showBtn="false">
            </hb-empty-state>
      </div>
      <div style="display: flex" v-else>
          <v-col cols="8" class="hb-default-font-size font-weight-medium">Swiper Terminals</v-col>
          <v-col cols="4" class="align-right">
            <a v-if="isEditing || !matchingDevices[0].Devices" @click="addDevice()">+ Add New Device</a> 
            
            </v-col>
      </div>
   
    <v-expansion-panels v-if="this.matchingDevices[0]?.Devices" multiple class="hb-expansion-panel ma-0 pa-0">   
    <v-expansion-panel class="ma-0 pa-0" v-for="(d, i) in matchingDevices[0].Devices" :key="i">
          <v-expansion-panel-header class="hb-table-label py-0 my-0 px-4 hb-subpanel-header">
              <v-col cols="8" class="pa-0 ma-0">
                  <span class="hb-default-font-size font-weight-medium">Device {{i+1}}</span>
              </v-col>
               <template v-slot:actions >
                  <div class="d-flex align-center mr-3">
                      <hb-link v-if="isEditing" @click="removeDevice(i)" class="hb-default-font-size">Remove</hb-link>
                      <template v-else>
					  
                      <hb-link small  @click="testDevice(i)" class="hb-default-font-size">Test Credit Card Reader</hb-link>
                      <loader v-show="testDeviceLoading === i" color="#00b2ce" size="20px" class="inline-loader"></loader>
                      </template>
                  </div>
                  <div class="d-flex align-center">
                    <v-icon>$expand</v-icon>
                  </div>
              </template> 
          </v-expansion-panel-header>
          <v-divider></v-divider>
          <v-expansion-panel-content class="py-0 my-0 px-0" elevation="0">
            <hb-form label="Device Name">
              <HbTextField
                :disabled="!isEditing"
                v-model="matchingDevices[0].Devices[i].name"
                v-validate="'required|max:100'"
                data-vv-name="device_name"
                data-vv-as="Device Name"
                :error="errors.collect('device_name').length > 0"
                placeholder="Enter Device Name"
              />
            </hb-form> 


            <hb-form label="Device IP Address">
              <div v-show="!isEditing" class="checkmark" >
              <span class="icon"></span><span v-if ="matchingDevices[0].Devices[i].lan==1"> Local Network </span><span v-if ="matchingDevices[0].Devices[i].lan==0"> Internet </span>
                
              </div>
              <v-row v-show ="(isEditing)">

              <hb-radio-group   class="mt-1" v-model="matchingDevices[0].Devices[i].lan" :mandatory="true" row>
                <div disable="true">Select the network communication type then enter the IP address.</div>
                <hb-radio value="0">
                  <template v-slot:label>
                Internet
              </template>
                </hb-radio>
                  <hb-radio value="1">
                  <template v-slot:label>
                Local Network
        </template>
                </hb-radio>
                
              </hb-radio-group>
            </v-row>

              <HbTextField
                :disabled="!isEditing"
                v-model="matchingDevices[0].Devices[i].ip"
                v-validate="{ required: true, regex: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/ ||  /^((([0-9a-fA-F]){1,4})\\:){7}([0-9a-fA-F]){1,4}$/}"
                data-vv-name="ip"
                data-vv-as="Device IP"
                :error="errors.collect('ip').length > 0"
                placeholder="Enter Device IP Address"
              />

              <HbTextField
                v-if="matchingDevices[0].Devices[i].lan == 1"
                :disabled="true"
                :v-model="matchingDevices[0].Devices[i].hostname ? matchingDevices[0].Devices[i].hostname : matchingDevices[0].Devices[i].hostname = 'device'+ (i+1) +'.pax.us'"
                data-vv-name="ip"
                data-vv-as="Device IP"
                :error="errors.collect('ip').length > 0"
                :placeholder="matchingDevices[0].Devices[i].hostname"
              />
              
            </hb-form> 



            <hb-form label="Device Port">
                <HbTextField
                  :disabled="!isEditing"
                  v-model="matchingDevices[0].Devices[i].port"
                  v-validate="{ required: true, regex: /^(?:[0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-6])$/}"
                  data-vv-name="device_port"
                  data-vv-as="Device Port"
                  :error="errors.collect('device_port').length > 0"
                  placeholder="Enter Device Port"
                />
              </hb-form> 


               <hb-form label="Device ID">
                  <HbTextField
                    :disabled="!isEditing"
                    v-model="matchingDevices[0].Devices[i].identifier"
                    v-validate="'required|max:100|numeric'"
                    data-vv-name="identifier"
                    :error="errors.collect('identifier').length > 0"
                    placeholder="Enter Device ID"
                  />

                 <v-row no-gutters class="" v-if="matchingDevices[0].Devices[i].lan == 1 && matchingDevices[0].Devices[i].ip && matchingDevices[0].Devices[i].port && matchingDevices[0].Devices[i].identifier"><span class="pt-2">Download Setup </span>  <HbBtn  @click="configueModel = 1" icon tooltip="Download" mdi-code="mdi-download" /></v-row>

              </hb-form>
              
              <hb-modal
      v-model="configueModel"
      v-if="configueModel"
      size="medium"
      title=" Configuring Tenant Payments"
      show-help-link
      > 
        <template v-slot:content>
          <div class="py-4 px-6">
            Click on to Download Terminal Installer download the zipped installer file in order to setup connection with the PAX terminal.
            Necessary Subsequent Steps for setting up (Important):            <br /><br />
            <ul>
              <li>Go to Downloads (or wherever your browser saves files)</li>
              <li>Locate and unzip the installer-device-"dn” (dn refers to your device number)</li>
              <li>Open the Readme file and adhere to the further instructions.</li>

            </ul>
          </div>
        </template>
        <template v-slot:actions>
            <hb-btn @click="downloadPaxFile(i)">
              Download Terminal Installer
          </hb-btn>
        </template>
      </hb-modal>
              
          </v-expansion-panel-content> 
            
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="d-flex justify-end">
            <hb-bottom-action-bar
                :cancel-off="!isEditing"
                @close="isEditing = false,fetchData()"
                v-if="hasPermission('manage_payment_gateways')"
                :top-border="false"
                style="max-width: 400px;"
            >
                <template v-slot:right-actions>
                <hb-btn v-if="!isEditing && matchingDevices[0]?.Devices" @click="isEditing = true">Edit</hb-btn>
                <hb-btn v-if="isEditing && matchingDevices[0]?.Devices" @click="save()">Save</hb-btn>
                </template>
            </hb-bottom-action-bar>
            </div>
      
  </dev>
</template>
<script>

// import BaseSettings from '../../BasePaymentSettingsForm.vue' ;
 import api from '../../assets/api.js';
 import moment from 'moment';
 import { notificationMixin } from '../../mixins/notificationMixin';
 import axios from 'axios';
 import https from 'https';



export default {
  name: 'CardReader',
  data() {
    return {
       
      devicePanel: [],
      matchingDevices: { 
        id: '',
        property_id: '', 
        value: {
          production: false
        }, 
        Devices: [],
      },
      data:"",
      testDeviceLoading:"",
      isEditing:false,
      configueModel: false,
    }
  },
 props: {
    property_id: {
      type: String
    }
  },
 mixins: [notificationMixin],

  watch: {
    property_id() {
        this.matchingDevices = " "
      this.fetchData();

    }
  },
  async created() {
    this.fetchData();
    
  },
  methods: {
   async fetchData(){
         this.data = await api.get(this, api.PROPERTIES + this.property_id +  '/connections');
          this.matchingDevices = this.data.connections
            .filter(conn => conn.name === "tenant_payments" && conn.type === "card")


            console.log(this.matchingDevices[0]?.Devices);
            this.isEditing=false

    },
    addDevice(){
         if(!this.matchingDevices[0].Devices){
        this.$set(this.matchingDevices[0], 'Devices', [])
            }
     
      this.matchingDevices[0].Devices.push({
          id: '',
          name: '',
          ip: '',
          port: '',
          identifier: '',
          hostname: ''
      })
      this.isEditing="true"
    }, 
    async save () {
      
      for(let i = 0; i < this.matchingDevices[0].Devices.length; i++){
        let status = await this.$validator.validate();
        if(this.matchingDevices[0].Devices[i].port =="" || !status){
          this.showMessageNotification({ type: 'error', description: 'There are errors in your form, correct them before continuing.',list: this.errors.items})
          return
        }
      }
      try{
        this.isEditing = false
        this.matchingDevices.property_id = this.property_id;

        // let status = await this.validate(this)

        // if(!status) return; // throw error?
        console.log("config", this.matchingDevices);
        if(this.matchingDevices[0].id){
          let r = await api.put(this, api.PROPERTIES + this.property_id + '/connections/' + this.matchingDevices[0].id, this.matchingDevices[0])
        } else {
          delete this.matchingDevices[0].id;
          let r = await api.post(this, api.PROPERTIES + this.property_id + '/connections', this.matchingDevices[0]);
        }
        this.showMessageNotification({ type: 'success', description: 'Payment Configuration saved successfully.' })
        this.fetchData()
      } catch(err){
        this.showMessageNotification({ description: err })
      }
    },
    async testDevice(i){
      try {
        this.testDeviceLoading = i;
		if (this.matchingDevices[0].Devices[i].lan == 1) {
			// Create an instance of the HTTPS agent with certificate verification enabled.
            const certData = `-----BEGIN CERTIFICATE-----
MIIDzTCCArWgAwIBAgIBAjANBgkqhkiG9w0BAQsFADBtMQswCQYDVQQGEwJVUzEL
MAkGA1UECAwCRkwxDDAKBgNVBAcMA0pBWDEMMAoGA1UECgwDUEFYMRQwEgYDVQQL
DAtJTlRFR1JBVElPTjEfMB0GA1UEAwwWUEFYVVMgVEVSTUlOQUwgUk9PVCBDQTAe
Fw0xODA4MDYwNzMyMTJaFw0yODA4MDMwNzMyMTJaMGoxCzAJBgNVBAYTAlVTMQsw
CQYDVQQIDAJGTDEMMAoGA1UECgwDUEFYMRQwEgYDVQQLDAtJTlRFR1JBVElPTjEq
MCgGA1UEAwwhUEFYVVMgVEVSTUlOQUwgU0VSVkVSIENFUlRJRklDQVRFMIIBIjAN
BgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwbJg+g0N/M+ohU4sTpNHY25j0tH3
6f6kk5M564g6/kBv8WWL/4QnpLHfGVFdBC+P30JW9QjOGJj5OY5suQm0xqs6/rD1
qb1cWbBaeTvOMmx+79uIuQweRAfbAOdc3RdKSz3nR/IfZ1059FG23/8IF9/pRXuM
oeFl4MzWwoxkqJ24Q216aD+fJvGNjoajuBbnyM+5WQDRqBE+GI04ElWDDLLft/Kx
cQwL/gjxFeGSmDg88yHPcimcIulnGnmc6M3SV5RbGVHbCtOwzwjQdUndom9lDZ82
VkBPUaYgiMnFzbbYF9FHFP2xD93qvWrBpc5GGQleDsH8LLHsXbZdPbvdnwIDAQAB
o3sweTAJBgNVHRMEAjAAMAsGA1UdDwQEAwIFoDAdBgNVHQ4EFgQUuWH25D/quAew
5neUSAjaqxe6LCUwHwYDVR0jBBgwFoAUKyQA82I7zBIeEmhqHya07aPrLHYwHwYD
VR0RBBgwFoIIKi5wYXgudXOHBH8AAAGHBMCoYnIwDQYJKoZIhvcNAQELBQADggEB
ADBQHlhlEHzmyVLiAoInaxbP7s8hN29VcWXUQXo5VrbfWCB26zfY0mFgZezMa7VB
dzzflJ/XeqDs+HgQ5KQ5cXL4PO+jpFvPLPj7wfy02YdyjuKu/EDMkrxLXwJm8TJY
qeVd/W5phCxqXc/+5jvvrGGdOTd+tgpz/DndKl4mdboqWeqCJxVWbxZez2FDrUzP
cPHhEt+gfJFr2ARYhPwf7jD5/97YV2ULeYxoOkr+qF5GdTdSxn944FM8l8ZGrRpe
rkhYcw+B0V6MgdoFGhkBDXbos0KiUUbLVgCyf+ewUQuc1+2q9++s+amJ0svydr1V
0gVZN3O9nql8n0IcpWtsyvQ=
-----END CERTIFICATE-----`;

			const httpsAgent = new https.Agent({
			  ca: [certData],
			});

			const instance = axios.create({
			  httpsAgent
			});

			// Make the GET request using the custom Axios instance.
			const response = await instance.get(`https://device${i + 1}.pax.us:${this.matchingDevices[0].Devices[i].port}?AkEwMBwxLjI4A0s=`, {headers: {'Accept': 'text/plain',},});
			console.log("response:", response.data);
			console.log("response:");
			console.log(response);
			this.deviceData = response.data;
            this.showMessageNotification({ type: 'success', description: 'Connected to the credit card reader successfully.' });
		} else {
          let r = await api.post(this, api.PROPERTIES + `${this.property_id}/connections/${this.matchingDevices[0].id}/devices/${this.matchingDevices[0].Devices[i].id}/validate`);
          this.showMessageNotification({ type: 'success', description: 'Connected to the credit card reader successfully.' });
		}
      } catch(err){
        this.showMessageNotification({ description: err.toString() });
      }
      this.testDeviceLoading = null;
      
    },
     async removeDevice(num){
      this.matchingDevices[0].Devices.splice(num, 1);

      try{
        this.isEditing = false
        this.matchingDevices.property_id = this.property_id;

        // let status = await this.validate(this)

        // if(!status) return; // throw error?
        console.log("config", this.matchingDevices);
        if(this.matchingDevices[0].id){
          let r = await api.put(this, api.PROPERTIES + this.property_id + '/connections/' + this.matchingDevices[0].id, this.matchingDevices[0])
        } else {
          delete this.matchingDevices[0].id;
          let r = await api.post(this, api.PROPERTIES + this.property_id + '/connections', this.matchingDevices[0]);
        }
        this.showMessageNotification({  description: 'Device removed.' })
        this.fetchData()
      } catch(err){
        this.showMessageNotification({ description: err })
      }

      
    },
    async downloadPaxFile(i) {


this.configueModel = false
this.matchingDevices[0].Devices[i].count=i
let response = await this.$http.post(api.PROPERTIES + this.property_id + '/connections/download', this.matchingDevices[0].Devices[i], { responseType: 'blob' });
                    let blob = new Blob([response.data], {
                        type: response.headers.get("content-type")
                    });
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `installer-device${i+1}${moment().utc().local().format('HH:mm:ss')}.zip`;
                    link.click();
                    delete this.matchingDevices[0].Devices[i].count
}

  },
}
</script>

